import React from "react";
import { Box, Container } from "@mui/material";
import { UserManagementToolbar } from "./pages/UserManagementToolbar";
import { UserListTable } from "./pages/UserListTable";

export function UserManagementUICard() {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth={false}>
        <UserManagementToolbar />
        <Box sx={{ mt: 3 }}>
          <UserListTable/>
        </Box>
      </Container>
    </Box>
  );
}
